import { atom } from "recoil";

export const orderInfoIsViewState = atom({
  key: "orderInfoIsViewState",
  default: false,
});
